import { render, staticRenderFns } from "./connect-button.vue?vue&type=template&id=b7ae705e"
import script from "./connect-button.vue?vue&type=script&lang=js"
export * from "./connect-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports